import { Box } from '@mui/material';

import PageHeader from '../../features/checkout/components/PageHeader';
import NotFoundPanel from '../../../shared/components/NotFoundPanel';

export default function NotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 1,
        height: 1,
      }}
    >
      <PageHeader />
      <NotFoundPanel />
    </Box>
  );
}
